import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import ScheduleItem from "./ScheduleItem";
import "./schedule.scss";

const useStyles = makeStyles({
  container: {
    height: "96vh",

    "@media (max-width: 768px)": {
      height: "unset",
    },
  },
  grid: {
    height: "96vh",

    "@media (max-width: 768px)": {
      height: "unset",
      margin: "unset",
    },
  },
});

const courseStyles = {
  toolbar1: {
    backgroundColor: "#fff8e7", 
    color: "#3e2c23", 
  },
  toolbar2: {
    backgroundColor: "#fffefa", 
    color: "#5c4033",
    height: "150px",
    marginBottom: "7px",
  },
  button1: {
    width: "100%",
    backgroundColor: "#d6a87a", 
    color: "white",
    "&:hover": { backgroundColor: "#b97c50" }, 
  },
  button2: {
    width: "100%",
    backgroundColor: "#fae8d1", 
    color: "#5c4033",
    height: "45px",
    "&:hover": { backgroundColor: "#f1d8be" },
  },
  typography: {
    fontSize: "17px",
    fontWeight: 600,
    color: "#3f2e1f", 
  },
  discountText: {
    color: "#8b5e3c", 
    fontWeight: 500,
  },
  proviso: {
    fontSize: "14px",
    color: "#9e9483", 
  },
};

const courses = [
  {
  course: {
    classPrefix: "card1",
    title: "Курс (очно/онлайн)",
    name: "Бухгалтерський облік та оподаткування(з можливістю працевлаштування)",
    start: "Щомісяця",
    group: "15800 грн",
    indiv: "20700 грн",
    hours: "89 ак.годин",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Григорєва Людмила Петрівна",
    proviso0: "Знижка 7% — за довідкою ВПО",
    proviso1: "Знижка 10% — при оплаті повної вартості курсу одним платежем",
    proviso2: "Знижка 20% — при реєстрації від двох осіб",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "1. Введення в спеціальність:",
      "• поняття господарчої діяльності та її облік;",
      "• реєстрація юридичної особи;",
      "• господарські процеси, які виникають на підприємстві та їх взаємозв’язок.",
      "",
      "2. Облікова політика підприємства:",
      "• типова політика;",
      "• затвердження політики підприємства.",
      "",
      "3. Бухгалтерський облік:",
      "• принципи БО;",
      "• предмет БО;",
      "• національні та міжнародні стандарти БО.",
      "",
      "4. Класифікація активів:",
      "• оборотні активи;",
      "• необоротні активи.",
      "",
      "5. Класифікація зобов’язань:",
      "• поточні зобов’язання;",
      "• довгострокові зобов’язання.",
      "",
      "6. План рахунків бухгалтерського обліку:",
      "• балансові рахунки: активні; пасивні; активно-пасивні;",
      "• позабалансові рахунки: для чого потрібні та їх облік;",
      "• синтетичні та аналітичні рахунки;",
      "• субрахунки як додаткові.",
      "",
      "7. Елементи бухгалтерського обліку та методи. Метод подвійного запису.",
      "",
      "8. Готівка та готівкові розрахунки:",
      "• «Положення про касу та касові операції»;",
      "• норми ведення каси;",
      "• документи для касових операцій;",
      "• штрафні санкції за порушення;",
      "• БО готівкових розрахунків.",
      "",
      "9. Розрахунки в банках:",
      "• відкриття/закриття рахунку в банку;",
      "• документи для розрахунків;",
      "• БО безготівкових розрахунків.",
      "",
      "10. Розрахунки з підзвітними особами:",
      "• сільськогосподарча закупівля;",
      "• господарчі потреби;",
      "• відрядження;",
      "• авансові звіти;",
      "• БО розрахунків з підзвітними особами.",
      "",
      "11. Розрахунки з постачальниками та підрядниками:",
      "• господарчий договір;",
      "• рахунки для БО;",
      "• перші поняття про ПДВ:",
      "  - податкові зобов’язання;",
      "  - податковий кредит;",
      "  - правило першої події;",
      "  - БО ПДВ.",
      "",
      "12. Запаси як оборотні активи:",
      "• зарахування на баланс;",
      "• первісна вартість залежно від способу появи запасів;",
      "• вартість вибуття;",
      "• методи вибуття;",
      "• БО запасів.",
      "",
      "13. Кредити:",
      "• поточні; довгострокові; види кредитів;",
      "• облік кредитів.",
      "",
      "14. Виплати найманим працівникам:",
      "• строки нарахування та виплати зарплати; законодавча база; документи;",
      "• нарахування зарплати:",
      "  - за фактично відпрацьований час (почасова, відрядна, оклад/тариф);",
      "  - поняття мінімальної зарплати;",
      "  - оплата в період відрядження; відпускні; лікарняні; премії; інші нарахування;",
      "• утримання із зарплати: ПДФО; військовий збір; аліменти та інші утримання;",
      "• нарахування та сплата ЄСВ;",
      "• матеріальна допомога: з податками; неоподатковувана; додаткове благо;",
      "• зарплата не грошима; БО виплат; звітність по зарплаті.",
      "",
      "15. Необоротні активи:",
      "• види вартості: первісна; ліквідаційна; амортизаційна; залишкова;",
      "• основні засоби; нематеріальні активи; інші матеріальні необоротні активи;",
      "• амортизація і методи; період корисного використання та експлуатації;",
      "• знос та ліквідація; БО необоротних активів.",
      "",
      "16. Інвентаризація:",
      "• необхідна за законодавством; за рішенням підприємства;",
      "• залишки та нестачі і їх БО; документування інвентаризації.",
      "",
      "17. Розрахунки з дебіторами:",
      "• поточна та довгострокова заборгованість;",
      "• сумнівні та безнадійні борги і їх облік;",
      "• документування розрахунків; БО розрахунків.",
      "",
      "18. Вексельна форма розрахунків:",
      "• поняття розрахунків з векселями; простий та переказний вексель;",
      "• БО векселів.",
      "",
      "19. Визнання доходів та витрат і їх облік.",
      "",
      "20. Фінансові результати діяльності:",
      "• збитки; прибутки і напрями їх використання; дивіденди та розподіл;",
      "• фінансова звітність:",
      "  - визначення звітів для статистики та податкової;",
      "  - баланс;",
      "  - звіт про фінрезультати;",
      "  - заповнення та строки подання.",
      "",
      "21. Податковий облік:",
      "• системи оподаткування в Україні; загальнодержавні та місцеві податки;",
      "• податок на прибуток; ПДВ; екологічний податок; земельний податок;",
      "• єдиний податок; податок на майно; туристичний, паркувальний, ринковий збори; інші платежі.",
      "По кожному податку:",
      "• платник; база оподаткування; ставки; строки сплати; пільги; декларація та її заповнення.",
      "",
      "22. Спрощена система оподаткування:",
      "• облік доходів та витрат; облік інших господарських операцій; звітність.",
      "",
      "23. Поворотна та безповоротна фінансова допомога:",
      "• письмовий договір; правила надання/отримання/повернення; бухгалтерський облік.",
      "",
      "24. Перевірки:",
      "• планові; позапланові невиїзні/виїзні; камеральні."
    ],
    makeStyles: courseStyles
  }
},
{
  course: {
    classPrefix: "card2",
    title: "Курс (очно/онлайн)",
    name: "Спеціаліст відділу кадрів. Рівень від інспектора до начальника відділу",
    start: "Уточнюйте дату старту",
    group: "7920 грн",
    indiv: "12900 грн",
    hours: "50 ак.годин",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Григорєва Людмила Петрівна",
    proviso0: "*Знижка 7% - за довідкою ВПО",
    proviso1: "*Знижка 10% - при оплаті повної вартості курсу одним платежем",
    proviso2: "*Знижка 20% - при реєстрації від двох осіб",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "1. Види трудових договорів",
      "2. Нетрудові договори",
      "3. Штатний розклад",
      "4. Правила внутрішнього розпорядку",
      "5. Посадова інструкція",
      "6. Час відпочинку",
      "7. Табель обліку робочого часу",
      "8. Оформлення прийому на роботу",
      "9. Особова справа (особова картка П-2)",
      "10. Практика / стажування",
      "11. Випробувальний термін",
      "12. Робочий час (неповний/скорочений день, нормування праці)",
      "13. Віддалена робота та гнучкий графік",
      "14. Сумісництво та суміщення",
      "15. Працевлаштування людей з інвалідністю",
      "16. Норматив робочих місць осіб з інвалідністю",
      "17. Відшкодування роботодавцю на облаштування робочого місця для осіб з інвалідністю",
      "18. Донорство",
      "19. Дистанційна робота",
      "20. Фрілансер",
      "21. Порядок працевлаштування іноземців",
      "22. Оплата праці",
      "23. Види оплати праці",
      "24. Відпустки (усі види)",
      "25. Припинення трудових відносин",
      "26. Трудова книжка",
      "27. Електронна трудова книжка",
      "28. Нове робоче місце",
      "29. Ведення військового обліку",
      "30. Атестація робочих місць",
      "31. Перевірки Держпраці",
      "32. Комісія / Уповноважений із соцстраху",
      "33. Припинення діяльності",
      "34. Тарифно-кваліфікаційний довідник",
      "35. Державний класифікатор"
    ],
    makeStyles: courseStyles
  }
},
 {
  course: {
    classPrefix: "card3",
    title: "Курс (очно/онлайн)",
    name: "Академія підприємця(ФОП). Повний курс ведення свого бізнесу",
    start: "Щомісяця",
    group: "4100 грн",
    indiv: "7100 грн",
    hours: "30 ак.годин",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Григорєва Людмила Петрівна",
    proviso0: "Знижка 7% — за довідкою ВПО",
    proviso1: "Знижка 10% — при оплаті повної вартості курсу одним платежем",
    proviso2: "Знижка 20% — при реєстрації від двох осіб",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "1. Отримання статусу «підприємець».",
      "2. Постановка на облік в ДПС.",
      "3. Системи оподаткування для ФОП. Право на зміну системи.",
      "4. Відпустка ФОПа.",
      "5. Оплата лікарняного ФОП.",
      "6. Дії ФОПа при зміні своїх персональних даних.",
      "7. Обов’язок зміни податкової.",
      "8. Грант ФОПу.",
      "9. Земельний податок.",
      "10. Транспортний збір.",
      "11. Податок на майно.",
      "12. Форма 20-ОПП. Ризики неподання.",
      "13. Документування діяльності.",
      "14. Готівка у ФОП. РРО / ПРРО.",
      "15. Безготівкові розрахунки. Рахунок ФОП у банку.",
      "16. Розрахунки з постачальниками та підрядниками.",
      "17. Використання власного майна в підприємницькій діяльності.",
      "18. Облік доходів ФОП.",
      "19. Пасивні доходи.",
      "20. Зарплата найманим працівникам:",
      "   • Нарахування зарплати:",
      "     - за фактично відпрацьований час;",
      "     - відпускні;",
      "     - лікарняні;",
      "     - премії і інші заохочувальні виплати.",
      "   • Утримання із нарахованої заробітної плати:",
      "     - ПДФО;",
      "     - Військовий збір;",
      "     - аліменти.",
      "   • Нарахування ЄСВ.",
      "",
      "21. Загальна система оподаткування:",
      "   • Оподаткування діяльності:",
      "     - база оподаткування;",
      "     - ставка ПДФО;",
      "     - ставка і база оподаткування Військового збору;",
      "     - облік доходів;",
      "     - облік витрат;",
      "     - амортизація;",
      "     - звітність.",
      "   • Отримання ліцензії.",
      "   • Податок на додану вартість (ПДВ).",
      "",
      "22. Спрощена система оподаткування:",
      "   • Розподіл на групи.",
      "   • По кожній групі:",
      "     - ліміт річного доходу;",
      "     - дозволені види діяльності;",
      "     - облік доходу;",
      "     - найняті працівники;",
      "     - звітність.",
      "",
      "23. Кадрове діловодство:",
      "   • Прийом на роботу та звільнення.",
      "   • Штатний розпис.",
      "   • Правила внутрішнього розпорядку.",
      "   • Відпустки.",
      "   • Документування діяльності.",
      "   • Трудова книжка."
    ],
    makeStyles: courseStyles
  }
},
    {
    course: {
      classPrefix: "card4",
      title: "Курс (очно/онлайн)",
      name: "Логістика в дії: навчання і практичні кейси",
      start: "На вибір",
      group: "6100 грн",
      indiv: "8700 грн",
      hours: "38 академічних годин",
      discount: "Знижка 7%",
      teacher: "Викладач: Карпенко Альбіна Валентинівна.",
      proviso3: "*Знижка 7% - за довідкою ВПО",
      program: "Програма навчання",
      order: "Записатись",
      courseProgram: [
        "1. Автовантажні перевезення та їх роль в економіці країни.",
        "2. Поняття про логістику. Історія логістики.", 
        "3. Призначення та функції логіста, диспетчера, експедитора.",
        "4. Участь і функції логіста в автотранспортних перевезеннях.",
        "5. Характеристика автотранспорту. Критерії вибору необхідного типу автомобіля з урахуванням виду вантажу.",
        "6. Вантаж. Вантажообробка.",
        "7. Розміщення вантажу у транспортному засобі відповідно до його властивостей:",
        "вантажі, що швидко псуються;",
        "важкі та негабаритні вантажі;",
        "штучні вантажі;",
        "насипи;",
        "навалювання;",
        "8. Участь логіста в підготовці вантажу для перевезення.",
        "9. Необхідна документація:",
        "заявка на перевезення;",
        "транспортне замовлення;",
        "договір перевезення;",
        "договір транспортного експедування;",
        "супровідні документи для перевезення вантажу.",
        "10. Розробка схеми оптимального маршруту перевезення.",
        "11. Відповідальність логіста під час доставки.",
        "12. Ціноутворення вантажного перевезення.",
        "13. Можливі ризики при перевезенні вантажів та їх мінімізація.",
        "14. Аналіз інформаційно-транспортних порталів та сайтів.",
        "15. Пошук нових клієнтів та навички ведення діалогу з ними.",
        "16. Законодавча база стосовно роботи логіста.",
        "17. Поточні тестування, завдання, шаблони документів.",
      ],
      makeStyles: courseStyles
    },
  },
  {
  course: {
    classPrefix: "card5",
    title: "Курс (очно/онлайн)",
    name: "Академія підприємця(ФОП). Без ведення кадрової роботи у ФОП",
    start: "Щомісяця",
    group: "3200 грн",
    indiv: "6100 грн",
    hours: "24 ак.години",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Григорєва Людмила Петрівна",
    proviso0: "Знижка 7% — за довідкою ВПО",
    proviso1: "Знижка 10% — при оплаті повної вартості курсу одним платежем",
    proviso2: "Знижка 20% — при реєстрації від двох осіб",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "1. Отримання статусу «підприємець».",
      "2. Постановка на облік в ДПС.",
      "3. Системи оподаткування для ФОП. Право на зміну системи.",
      "4. Відпустка ФОПа.",
      "5. Оплата лікарняного ФОП.",
      "6. Дії ФОПа при зміні своїх персональних даних.",
      "7. Обов’язок зміни податкової.",
      "8. Грант ФОПу.",
      "9. Земельний податок.",
      "10. Транспортний збір.",
      "11. Податок на майно.",
      "12. Форма 20-ОПП. Ризики неподання.",
      "13. Документування діяльності.",
      "14. Готівка у ФОП. РРО / ПРРО.",
      "15. Безготівкові розрахунки. Рахунок ФОП у банку.",
      "16. Розрахунки з постачальниками та підрядниками.",
      "17. Використання власного майна в підприємницькій діяльності.",
      "18. Облік доходів ФОП.",
      "19. Пасивні доходи.",
      "20. Зарплата найманим працівникам:",
      "   • Нарахування зарплати:",
      "     - за фактично відпрацьований час;",
      "     - відпускні;",
      "     - лікарняні;",
      "     - премії і інші заохочувальні виплати.",
      "   • Утримання із нарахованої заробітної плати:",
      "     - ПДФО;",
      "     - Військовий збір;",
      "     - аліменти.",
      "   • Нарахування ЄСВ.",
      "",
      "21. Загальна система оподаткування:",
      "   • Оподаткування діяльності:",
      "     - база оподаткування;",
      "     - ставка ПДФО;",
      "     - ставка і база оподаткування Військового збору;",
      "     - облік доходів;",
      "     - облік витрат;",
      "     - амортизація;",
      "     - звітність.",
      "   • Отримання ліцензії.",
      "   • Податок на додану вартість (ПДВ).",
      "",
      "22. Спрощена система оподаткування:",
      "   • Розподіл на групи.",
      "   • По кожній групі:",
      "     - ліміт річного доходу;",
      "     - дозволені види діяльності;",
      "     - облік доходу;",
      "     - найняті працівники;",
      "     - звітність."
    ],
    makeStyles: courseStyles
  }
},
{
  course: {
    classPrefix: "card6",
    title: "Курс (очно/онлайн)",
    name: "Бухгалтерський облік у військовій частині",
    start: "За запитом",
    group: "Не передбачено",
    indiv: "14900 грн",
    hours: "40 ак.годин",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Лоік Інна Володимирівна",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "1. Бухгалтерський облік (БО):",
      "• предмет бухгалтерського обліку;",
      "• план рахунків в бухгалтерському обліку.",
      "",
      "2. Бухгалтерський облік у військовій частині:",
      "• особливості бухгалтерського обліку у військовій частині;",
      "• порядок ведення бухгалтерського обліку;",
      "• облікова політика військової частини.",
      "",
      "3. Документування:",
      "• основи документообігу та архівного зберігання в бухгалтерії військової частини.",
      "",
      "4. Асигнування військової частини.",
      "5. Облік бюджетного фінансування у військовій частині.",
      "6. Облік гуманітарної допомоги у військовій частині.",
      "7. Допомога армії, пов’язана з діяльністю юридичної особи.",
      "8. Облік розрахунків з підзвітними особами.",
      "9. Розрахунки з постачальниками і підрядниками у військовій частині.",
      "",
      "10. Запаси:",
      "• облік матеріальних запасів у військовій частині;",
      "• облік основних засобів у військовій частині, амортизація;",
      "• матеріально-відповідальна особа (МВО);",
      "• облік речового майна у військовій частині;",
      "• бухгалтерський облік миючих засобів, канцтоварів, інвентаря;",
      "• облік продуктів харчування у військовій частині;",
      "• облік і списання пального у військовій частині;",
      "• переоцінка запасів у військовій частині в бухгалтерському обліку.",
      "",
      "11. Бухгалтерський облік конфіскованих автомобілів та іншої техніки.",
      "12. Списання медикаментів і ліків.",
      "13. Інвентаризація та переоцінка майна у військовій частині.",
      "14. Військове майно (ремонти).",
      "15. Облік грошових коштів у військовій частині.",
      "",
      "16. Грошове забезпечення військової частини:",
      "• відомості нарахування заробітної плати, грошового забезпечення (форма ФС-6);",
      "• розрахунок лікарняних;",
      "• розрахунок відпускних військовослужбовців;",
      "• виплати військовим при звільненні.",
      "",
      "17. Фінансова звітність у військовій частині:",
      "• Баланс (форма 1-дс);",
      "• Звіт про фінансові результати діяльності (форма 2-дс).",
      "",
      "18. Контроль і аудит бухгалтерського обліку у військовій частині.",
      "19. Меморіальні ордери.",
      "20. План рахунків.",
      "21. Додатки."
    ],
    makeStyles: courseStyles
  }
},
{
  course: {
    classPrefix: "card7",
    title: "Курс (очно/онлайн)",
    name: "«Виконавчий асистент. Помічник керівника»",
    start: "За запитом",
    group: "6900 грн",
    indiv: "11900 грн",
    hours: "45 ак.годин",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Григорєва Людмила Петрівна",
    proviso0: "*Знижка 7% - за довідкою ВПО",
    proviso1: "*Знижка 10% - при оплаті повної вартості курсу одним платежем",
    proviso2: "*Знижка 20% - при реєстрації від двох осіб",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "1. Вступ до професії:",
      "• роль і місце в структурі компанії;",
      "• етика і культура ділового спілкування;",
      "• професійний імідж.",
      "",
      "2. Діловодство та документальне забезпечення управління:",
      "• законодавча база;",
      "• види управлінських документів та їх класифікація;",
      "• організація документообігу;",
      "• номенклатура справ;",
      "• архівування документів.",
      "",
      "3. Ділове спілкування та комунікації:",
      "• усне та письмове ділове мовлення;",
      "• телефонний етикет;",
      "• ділові переговори, зустрічі, наради;",
      "• вирішення конфліктів.",
      "",
      "4. Організація роботи керівника:",
      "• планування робочого часу;",
      "• ведення календаря, складання графіків;",
      "• організація ділових зустрічей, конференцій, презентацій.",
      "",
      "5. Психологія та етика ділових відносин.",
      "",
      "6. Основи менеджменту та маркетингу:",
      "• поняття управління та лідерства;",
      "• основи організаційної культури.",
      "",
      "7. Положення про комерційну таємницю та робота з конфіденційною інформацією.",
      "",
      "8. Excel, Word для офісного робітника:",
      "• форматування тексту, шрифт, абзац, списки;",
      "• основні атрибути офісного документа. Створення наказу, запиту;",
      "• таблиці, створення реєстрів документів;",
      "• стилі оформлення документа;",
      "• автозаміна, автотекст, шаблони;",
      "• проста формула та види її створення (з постійними або збереженими діапазонами);",
      "• сортування, фільтр, діаграма;",
      "• створення таблиць та їх збереження у різних форматах, зв’язок Excel з іншими програмами;",
      "• зведені таблиці."
    ],
    makeStyles: courseStyles
  }
},
  {
  course: {
    classPrefix: "card8",
    title: "Курс (очно/онлайн)",
    name: "Менеджмент персоналу. HR-Менеджер",
    start: "За запитом",
    group: "не передбачено",
    indiv: "15900 грн",
    hours: "50 ак.годин",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Григорєва Людмила Петрівна",
    proviso0: "Знижка 7% — за довідкою ВПО",
    proviso1: "Знижка 10% — при оплаті повної вартості курсу одним платежем",
    proviso2: "Знижка 20% — при реєстрації від двох осіб",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "Блок 1. Системи керування:",
      "1) типи систем",
      "2) переваги та недоліки",
      "3) практичні рекомендації",
      "",
      "Блок 2. Керуючий (менеджер) персоналом:",
      "1) функції у зв'язку з етапами роботи підприємства",
      "2) цілі управління",
      "3) методи управління",
      "4) кадрова політика",
      "",
      "Блок 3. Підбір персоналу:",
      "1) визначення вимог до кандидатів",
      "2) методи підбору",
      "3) співбесіда та аналіз її результатів",
      "",
      "Блок 4. Адаптація:",
      "1) трудова адаптація",
      "2) соціальна адаптація",
      "3) куратор",
      "4) документування результатів",
      "",
      "Блок 5. Кар'єра:",
      "1) види кар'єри",
      "2) план кар'єрного зростання",
      "3) етапи кар'єри",
      "4) аналіз результатів",
      "",
      "Блок 6. Підвищення кваліфікації та навчання персоналу:",
      "1) визначення необхідності підвищення чи навчання",
      "2) мета навчання — навіщо, що хочемо отримати у результаті",
      "3) форми навчання або підвищення кваліфікації",
      "4) визначення ефекту проведених заходів",
      "5) підрахунок ККД",
      "",
      "Блок 7. Оцінка персоналу:",
      "1) способи та методи оцінки",
      "2) аналіз зайнятості",
      "3) визначення «незавантажених зайвих» працівників",
      "4) забезпечення зайнятості персоналу",
      "",
      "Блок 8. Мотивація:",
      "1) аналіз анкет, заповнених при прийомі на роботу",
      "2) мотивація для персоналу конкретного підприємства",
      "3) види мотивації",
      "4) необхідність мотивації",
      "",
      "Блок 9. Корпоративна культура:",
      "1) стихійно сформована культура",
      "2) визначення основних напрямів розвитку корпоративної культури",
      "3) план формування корпоративної культури",
      "4) розробка положення про корпоративну культуру",
      "5) вигоди планової корпоративної культури"
    ],
    makeStyles: courseStyles
  }
},
   {
    course: {
      classPrefix: "card9",
      title: "Курс (очно/онлайн)",
      name: "Міжнародна логістика",
      start: "Щомісяця",
      group: "3900 грн",
      indiv: "5900 грн",
      hours: "24 ак.годин",
      discount: "Знижка від 7% до 20%",
      teacher: "Викладач: Карпенко Альбіна Валентинівна",
      proviso0: "Знижка 7% - за довідкою ВПО",
      proviso1: "Знижка 10% - при оплаті повної вартості курсу одним платежем",
      proviso2: "*Знижка 20% - при реєстрації від двох осіб",
      program: "Програма навчання",
      order: "Записатись",
      courseProgram: [
        "1. Основні поняття та принципи міжнародних перевезень вантажів та участь логіста  в них.",
        "2. Нормативно-правове врегулювання перевезення вантажів у міжнародному сполученні.",
        "3. Необхідна документація для міжнародних перевезень:",
        "міжнародна товарно-транспортна накладна (CMR);",
        "інвойс та пакувальний лист;",
        "сертифікати відповідності та походження;",
        "дозвільні документи (для спеціальних вантажів);",
        "митна декларація.",
        "Види договорів:",
        "- перевезення;",
        "- чартеру;",
        "- найму;",
        "- транспортного експедирування.",
        "4. Митна конвенція про міжнародні перевезення вантажів : загальна характеристика. Основні принципи та положення TIR.",
        "5. Відповідальність та обов’язки : логіста, перевізника, замовника.",
        "6. Правила міжнародних автомобільних перевезень.",
        "7. Міжнародні грузові перевезення по типу товару та спеціальні вимоги до умов перевезення:",
        "стандартні вантажі;",
        "продукти харчування та швидкопсувні товари;",
        "великогабаритні та нестандартні конструкції;",
        "збірні вантажі.",
        "8. Угода про транспортний для українських вантажів.",
        "9. Аналіз інформаційно-транспортних порталів. Тестові завдання, практичні кейси.",
      ],
      makeStyles: courseStyles
    },
  },
{
  course: {
    classPrefix: "card10",
    title: "Курс (очно/онлайн)",
    name: "Управління в бізнесі: від аналізу до впровадження",
    start: "За запитом",
    group: "не передбачено",
    indiv: "14100 грн",
    hours: "44 ак.години",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Катичева Аліна Валентинівна",
    proviso0: "Знижка 7% — за довідкою ВПО",
    proviso1: "Знижка 10% — при оплаті повної вартості курсу одним платежем",
    proviso2: "Знижка 20% — при реєстрації від двох осіб",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "1. Бізнес-адміністрування:",
      "• визначення метода побудови бізнес-проєктів;",
      "• вплив внутрішнього та зовнішнього середовища;",
      "• програми Microsoft Project в структурі адміністрування.",
      "",
      "2. Менеджмент:",
      "• що це таке;",
      "• значення менеджменту;",
      "• як управляти рішеннями;",
      "• основна функція менеджменту.",
      "",
      "3. Фінансовий менеджмент:",
      "• прогнозування та контроль;",
      "• фінансові проблеми і методи їх визначення;",
      "• планування в фінансах.",
      "",
      "4. Оперативний менеджмент:",
      "• проєкт, його планування та контроль;",
      "• менеджмент якістю продукту;",
      "• інструменти проєктного менеджменту.",
      "",
      "5. Інвестиційний менеджмент:",
      "• його теоретичні основи;",
      "• інноваційні підприємства і управління ними;",
      "• управління фінансуванням таких підприємств.",
      "",
      "6. Аналіз фінансового стану підприємства:",
      "• економічна оцінка діяльності;",
      "• основні показники фінансового стану та їх діагностика;",
      "• ефективність використання капіталу підприємства.",
      "",
      "7. Маркетинг:",
      "• дослідження і сегменти ринку;",
      "• цінова політика;",
      "• політика продажів товару.",
      "",
      "8. Ціноутворення:",
      "• зв'язок ціни з економікою підприємства;",
      "• аналіз системи цін;",
      "• механізм і алгоритм ціноутворення.",
      "",
      "9. Управління розвитком:",
      "• інноваційний розвиток підприємства;",
      "• потенціал підприємства, його оцінка та аналіз;",
      "• управління вибором напрямку діяльності;",
      "• інноваційні розробки;",
      "• ресурси підприємства і управління ними.",
      "",
      "10. Бізнес-план інноваційного проєкту:",
      "• основи управління інноваційними проєктами;",
      "• бізнес-планування і його структура;",
      "• бізнес-планування з точки зору фінансів."
    ],
    makeStyles: courseStyles
  }
},
{
  course: {
    classPrefix: "card11",
    title: "Курс (очно/онлайн)",
    name: "Фінансовий директор",
    start: "За запитом",
    group: "не передбачено",
    indiv: "13600 грн",
    hours: "42 ак.години",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Катичева Аліна Валентинівна",
    proviso0: "Знижка 7% — за довідкою ВПО",
    proviso1: "Знижка 10% — при оплаті повної вартості курсу одним платежем",
    proviso2: "Знижка 20% — при реєстрації від двох осіб",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "1. Роль фінансового директора у бізнесі та його зони відповідальності:",
      "• Фінансовий директор в управлінні бізнесом.",
      "• Етапи розвитку функцій управління фінансами в бізнесі.",
      "• Організація структури фінансового відділу.",
      "• Інструменти управління фінансами.",
      "",
      "2. Первинна інформація для створення управлінських звітів:",
      "• Оперативний облік підприємства.",
      "• Статистичний облік підприємства.",
      "• Бухгалтерська звітність для управлінських звітів.",
      "",
      "3. Управлінська звітність. Cash Flow:",
      "• Побудова звіту про рух грошових коштів.",
      "• Аналіз звіту про рух грошових коштів.",
      "",
      "4. Методи обліку витрат:",
      "• Метод подвійного запису — основа трьох звітів.",
      "• Основні підходи до обліку витрат. Метод повного поглинання. Маржинальний метод.",
      "• Побудова звіту про прибутки та збитки (P&L).",
      "• Синхронізація звітів P&L та Cash Flow.",
      "",
      "5. Баланс. Верифікація звітності:",
      "• Структура та логіка побудови балансу.",
      "• Упорядкування первинного балансу.",
      "• Верифікація звітності.",
      "",
      "6. Бюджетування:",
      "• Бюджет. Його моделі та відмінності.",
      "• Прогнозування продажів.",
      "• Прогнозування витрат.",
      "• Створення платіжного календаря та його важливість у бізнесі.",
      "",
      "7. Методи фінансового аналізу:",
      "• Фінансовий аналіз: основні методи та розрахунок показників.",
      "• Аналіз відхилень, точка беззбитковості.",
      "• Вибір ключових показників."
    ],
    makeStyles: courseStyles
  }
},
{
  course: {
    classPrefix: "card12",
    title: "Курс (очно/онлайн)",
    name: "Навчальний курс Excel. Базовий рівень",
    start: "Щомісяця",
    group: "3900 грн",
    indiv: "6100 грн",
    hours: "20 ак.годин",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Катичева Аліна Валентинівна",
    proviso0: "Знижка 7% — за довідкою ВПО",
    proviso1: "Знижка 10% — при оплаті повної вартості курсу одним платежем",
    proviso2: "Знижка 20% — при реєстрації від двох осіб",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "1. Знайомство з інтерфейсом Excel:",
      "• Основні елементи інтерфейсу програми.",
      "• Робоча область: як змінювати розмір комірок.",
      "• Робота з аркушами: створення, перейменування, переміщення.",
      "• Введення та форматування даних у комірках.",
      "• Використання автоматичного заповнення комірок.",
      "• Практичне заняття: робота з інтерфейсом та введенням даних.",
      "",
      "2. Форматування комірок:",
      "• Типи даних у Excel: числовий, текстовий, дата, валюта тощо.",
      "• Зміна формату даних для зручного відображення.",
      "• Додавання та редагування меж комірок.",
      "• Налаштування кольору, шрифту та вирівнювання тексту.",
      "• Практичне заняття: форматування таблиці з різними типами даних.",
      "",
      "3. Використання формул у Excel:",
      "• Створення простих формул (додавання, віднімання, множення, ділення).",
      "• Використання постійних значень у формулах.",
      "• Робота з діапазонами даних у формулах.",
      "• Практичне заняття: складання формул для підрахунків у таблиці.",
      "",
      "4. Робота з даними: сортування, фільтри, діаграми:",
      "• Сортування даних за зростанням та спаданням.",
      "• Використання фільтрів для вибірки необхідної інформації.",
      "• Створення та налаштування діаграм (графіків).",
      "• Практичне заняття: аналіз даних за допомогою сортування, фільтрів та діаграм.",
      "",
      "5. Створення таблиць та робота з файлами:",
      "• Як створювати та налаштовувати таблиці.",
      "• Збереження файлів у різних форматах (Excel, PDF, CSV тощо).",
      "• Способи експорту даних та взаємодія Excel з іншими програмами.",
      "• Практичне заняття: збереження та обмін файлами.",
      "",
      "6. Зведені таблиці (Pivot Tables):",
      "• Що таке зведені таблиці та для чого вони потрібні.",
      "• Створення та налаштування зведених таблиць.",
      "• Аналіз та групування даних у зведених таблицях.",
      "• Практичне заняття: створення зведеної таблиці для аналізу даних."
    ],
    makeStyles: courseStyles
  }
},
{
  course: {
    classPrefix: "card13",
    title: "Курс (очно/онлайн)",
    name: "Навчальний курс Excel. Поглиблений рівень",
    start: "Щомісяця",
    group: "3900 грн",
    indiv: "6100 грн",
    hours: "20 ак.годин",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Катичева Аліна Валентинівна",
    proviso0: "Знижка 7% — за довідкою ВПО",
    proviso1: "Знижка 10% — при оплаті повної вартості курсу одним платежем",
    proviso2: "Знижка 20% — при реєстрації від двох осіб",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "1. Логічні розрахунки:",
      "• Базові логічні функції: ЯКЩО, ТА, АБО — умовні обчислення та автоматизація прийняття рішень.",
      "• Практика: створення формул з умовами, аналіз звітних даних.",
      "",
      "2. Розрахунки з посиланням на масиви:",
      "• Функції пошуку та зв'язків: ВПР, ГПР, ІНДЕКС, ПОШУКПОЗ.",
      "• Практика: автоматичне підтягання значень з інших таблиць, побудова систем зв'язків.",
      "",
      "3. Текстові операції:",
      "• Обробка тексту: з'єднання тексту, вирізання частин, зміна регістру, TRIM/видалення зайвих пробілів тощо.",
      "• Практика: очищення баз даних, формування підписів і автоматичних заголовків.",
      "",
      "4. Макроси:",
      "• Автоматизація дій у Excel за допомогою макросів для щоденних задач.",
      "• Практика: створення власних макросів для спрощення роботи.",
      "",
      "5. Запити (Power Query):",
      "• Імпорт, очищення та трансформація великих обсягів даних.",
      "• Практика: об'єднання таблиць, фільтрація та структурування даних з різних джерел.",
      "",
      "6. Перехід у Power BI:",
      "• Основи роботи з Power BI: підключення Excel, створення простих дашбордів.",
      "• Практика: побудова інтерактивного звіту на основі таблиці з Excel."
    ],
    makeStyles: courseStyles
  }
},
{
  course: {
    classPrefix: "card14",
    title: "Курс (очно/онлайн)",
    name: "Користувач Microsoft Word + Google таблиці + ШІ",
    start: "Щомісяця",
    group: "3900 грн",
    indiv: "5100 грн",
    hours: "18 ак.годин",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Катичева Аліна Валентинівна",
    proviso0: "Знижка 7% — за довідкою ВПО",
    proviso1: "Знижка 10% — при оплаті повної вартості курсу одним платежем",
    proviso2: "Знижка 20% — при реєстрації від двох осіб",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "1. Інтерфейс програми. Встановлення Штучного Інтелекту для текстового редактора.",
      "2. Форматування тексту: шрифт, абзац, списки, основні атрибути офісного документа.",
      "3. Створення схем: робота з фігурами та схемами. Використання Штучного Інтелекту для форматування фото та схем.",
      "4. Таблиці та Google таблиці: створення, редагування, спільна робота.",
      "5. Стилі оформлення документа: шаблони, автоматичне форматування, узгодженість стилів.",
      "6. Автозміна документа: автотекст, автозаміна, шаблони. Створення макросів за допомогою Штучного Інтелекту."
    ],
    makeStyles: courseStyles
  }
},
{
  course: {
    classPrefix: "card15",
    title: "Курс (очно/онлайн)",
    name: "Excel + Word для секретарів, офіс-менеджерів, адміністраторів та референтів",
    start: "Щомісяця",
    group: "4100 грн",
    indiv: "6100 грн",
    hours: "30 ак.годин",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Катичева Аліна Валентинівна",
    proviso0: "Знижка 7% — за довідкою ВПО",
    proviso1: "Знижка 10% — при оплаті повної вартості курсу одним платежем",
    proviso2: "Знижка 20% — при реєстрації від двох осіб",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "1. Інтерфейс програми Word: налаштування інструментів і вкладок під потреби користувача.",
      "2. Форматування тексту: шрифт, абзац, списки.",
      "3. Основні атрибути офісного документу: створення наказу, запиту.",
      "4. Створення схем: робота з фігурами та схемами. Робота з фірмовим стилем програми.",
      "5. Таблиці у Word: створення реєстрів документів.",
      "6. Стилі оформлення документа.",
      "7. Автозаміна, автотекст, шаблони.",
      "8. Інтерфейс програми Excel.",
      "9. Зміна розміру робочої частини комірок. Аркуші.",
      "10. Форматування даних. Автоматичне заповнення комірок.",
      "11. Формат комірки та їх види: числовий формат даних, границі комірок.",
      "12. Налаштування виду даних.",
      "13. Прості формули та способи їх створення: з постійними даними та збереженими діапазонами.",
      "14. Сортування, фільтр, діаграми.",
      "15. Створення таблиць та збереження у різних форматах. Зв'язок Excel з іншими програмами.",
      "16. Зведені таблиці."
    ],
    makeStyles: courseStyles
  }
},
{
  course: {
    classPrefix: "card16",
    title: "Курс (очно/онлайн)",
    name: "Microsoft Power Point",
    start: "Щомісяця",
    group: "4100 грн",
    indiv: "5600 грн",
    hours: "16 ак.годин",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Катичева Аліна Валентинівна",
    proviso0: "Знижка 7% — за довідкою ВПО",
    proviso1: "Знижка 10% — при оплаті повної вартості курсу одним платежем",
    proviso2: "Знижка 20% — при реєстрації від двох осіб",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "1. Основи PowerPoint",
      "Інтерфейс PowerPoint:",
      "• основні функції та можливості PowerPoint;",
      "• огляд вкладок, режимів роботи та видів макету слайдів;",
      "• створення та налаштування макету слайда.",
      "",
      "Робота зі слайдами:",
      "• додавання, переміщення та видалення слайдів;",
      "• оформлення слайду: форматування тексту, абзацу та списку;",
      "• растрова та векторна графіка;",
      "• створення таблиць;",
      "• режими налаштування презентації: звичайний, сортувальний, режим доповідача;",
      "• збереження презентації.",
      "",
      "2. Візуальне оформлення",
      "Робота з блоками:",
      "• додавання блока;",
      "• зміна розміру блока;",
      "• видалення блоку;",
      "• додавання різних об'єктів до блоку.",
      "",
      "Робота з графічними об'єктами:",
      "• створення та редагування автофігур;",
      "• створення блок-схем;",
      "• створення назв слайдів за допомогою растрової та векторної графіки.",
      "",
      "3. Анімація та мультимедіа",
      "Анімація:",
      "• типи та види анімації;",
      "• анімація для привертання уваги до презентації.",
      "",
      "Відео та аудіо. Підготовка до показу презентації:",
      "• вставка та налаштування відео та аудіо;",
      "• переходи між слайдами;",
      "• налаштування часу та порядку анімації блоків та слайдів.",
      "",
      "4. Практика, презентаційні навички та експорт",
      "Підготовка до виступу:",
      "• принципи дизайну презентації;",
      "• структура презентації: ділова, навчальна та рекламна;",
      "• практика виступу з презентацією.",
      "",
      "Підсумковий проєкт:",
      "• створення власної презентації;",
      "• подача презентації;",
      "• структура доповіді;",
      "• експорт презентації."
    ],
    makeStyles: courseStyles
  }
},
{
  course: {
    classPrefix: "card17",
    title: "Курс (очно/онлайн)",
    name: "BAS/1C Бухгалтерія ПРОФ",
    start: "Щомісяця",
    group: "4910 грн",
    indiv: "7910 грн",
    hours: "24 ак.години",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Лоік Інна Володимирівна",
    proviso0: "Знижка 7% — за довідкою ВПО",
    proviso1: "Знижка 10% — при оплаті повної вартості курсу одним платежем",
    proviso2: "Знижка 20% — при реєстрації від двох осіб",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "1. Характеристика концепції системи BAS/1C Бухгалтерія, загальні механізми і принципи функціонування.",
      "2. Налаштування конфігурації на облік у конкретній фірмі: створення інформаційних баз, внесення початкових залишків, дані про підприємство та його структуру, правильний початок роботи.",
      "3. Інтерфейс і меню програми. Основні елементи системи (константи, плани рахунків, довідники, документи, журнали документів, звітність) та правила роботи з ними.",
      "4. Довідники: види, заповнення, структура.",
      "5. Документи: порядок заповнення, обов’язкова послідовність операцій.",
      "6. Облік операцій придбання товарів та послуг.",
      "7. Облік операцій реалізації товарів та послуг.",
      "8. Робота з покупцями та постачальниками. Аналіз взаєморозрахунків з контрагентами.",
      "9. Документальне оформлення повернення.",
      "10. Складські операції.",
      "11. Виробництво продукції та послуг.",
      "12. Облік малоцінних активів.",
      "13. Облік операцій з грошовими засобами (банківські та касові операції).",
      "14. Купівля, введення в експлуатацію, зміна стану, вибуття основних засобів та нематеріальних активів.",
      "15. Кадровий облік: створення нового співробітника, заповнення особистих даних, прийняття на роботу.",
      "16. Кадрові документи: накази про переведення, звільнення, особові картки та інше.",
      "17. Облік розрахунків за заробітною платою (нарахування, виплата, сплата податків).",
      "18. Звіти: створення, налаштування, заповнення звітності.",
      "19. Формування стандартних та спеціальних звітів (оборотно-сальдова відомість, аналіз рахунку тощо).",
      "20. Формування регламентованих звітів (на прикладі Декларації з ПДВ)."
    ],
    makeStyles: courseStyles
  }
},
{
  course: {
    classPrefix: "card18",
    title: "Курс (очно/онлайн)",
    name: "BAS/1C Бухгалтерія КОРП",
    start: "Щомісяця",
    group: "6140 грн",
    indiv: "9400 грн",
    hours: "30 ак.годин",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Лоік Інна Володимирівна",
    proviso0: "Знижка 7% — за довідкою ВПО",
    proviso1: "Знижка 10% — при оплаті повної вартості курсу одним платежем",
    proviso2: "Знижка 20% — при реєстрації від двох осіб",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "Блок 1: Налаштування обліку та початкові залишки.",
      "Блок 2: Каса, авансові звіти та інші розрахункові операції.",
      "Блок 3: Безготівкові операції.",
      "Блок 4: Розрахунки з постачальниками / виконавцями.",
      "Блок 5: Розрахунки з покупцями / замовниками.",
      "Блок 6: Складський облік.",
      "Блок 7: Виробництво продукції та послуг.",
      "Блок 8: Зарплата та кадри.",
      "Блок 9: Облік необоротних та матеріальних активів.",
      "Блок 10: ПДВ.",
      "Блок 11: Звітність (у т.ч. фінансова)."
    ],
    makeStyles: courseStyles
  }
},
{
  course: {
    classPrefix: "card19",
    title: "Курс (очно/онлайн)",
    name: "BAS/1C. Кадровий облік та зарплата",
    start: "За запитом",
    group: "не передбачено",
    indiv: "4800 грн",
    hours: "16 ак.годин",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Лоік Інна Володимирівна",
    proviso0: "Знижка 7% — за довідкою ВПО",
    proviso1: "Знижка 10% — при оплаті повної вартості курсу одним платежем",
    proviso2: "Знижка 20% — при реєстрації від двох осіб",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "1. Виробничий календар та графіки роботи.",
      "2. Способи відображення витрат по зарплаті.",
      "3. Створення посад та штатного розкладу.",
      "4. Налаштування базових місяців для розрахунку індексації.",
      "5. Налаштування параметрів виплати податків із заробітної плати.",
      "6. Прийом на роботу (повний день, основне місце роботи) ...",
      "7. Неповний робочий день (основне місце та внутрішнє сумісництво).",
      "8. Зовнішнє сумісництво.",
      "9. Працівник з інвалідністю.",
      "10. Працівник з податковою соціальною пільгою.",
      "11. Працівник з утриманням аліментів (виконавчим листом).",
      "12. Договори цивільно-правового характеру (ЦПХ).",
      "13. Відпустки — залишки, графік, розрахунок та нарахування, виплата.",
      "14. Нарахування резерву відпусток.",
      "15. Лікарняні за рахунок підприємства та ФСС.",
      "16. Підвищення окладу працівнику та зміна інших даних.",
      "17. Виплата авансу за фактично відпрацьований час.",
      "• Нарахування та виплата основної заробітної плати.",
      "• Звільнення та розрахунок працівника."
    ],
    makeStyles: courseStyles
  }
},
{
  course: {
    classPrefix: "card20",
    title: "Курс (очно/онлайн)",
    name: "BAS. Кадри з оновленим військовим обліком",
    start: "За запитом",
    group: "не передбачено",
    indiv: "6300 грн",
    hours: "20 ак.годин",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Лоік Інна Володимирівна",
    proviso0: "Знижка 7% — за довідкою ВПО",
    proviso1: "Знижка 10% — при оплаті повної вартості курсу одним платежем",
    proviso2: "Знижка 20% — при реєстрації від двох осіб",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "1. Кадровий облік:",
      "• співробітники;",
      "• прийом на роботу;",
      "• кадрові переведення;",
      "• звільнення;",
      "• відрядження;",
      "• звіти по кадрах.",
      "",
      "2. Зарплата:",
      "• нарахування зарплати;",
      "• відображення нарахування в бухгалтерському обліку;",
      "• індексація;",
      "• зміна параметрів розрахунку індексації;",
      "• введення відомостей про індексований дохід;",
      "• довідки про дохід працівника;",
      "• звіти про зарплату.",
      "",
      "3. ПДФО:",
      "• утримання ПДФО і військового збору;",
      "• відображення податку і збору в звітності;",
      "• заява на застосування податкової соціальної пільги;",
      "• відображення податку, збору і пільги в звітності про зарплату.",
      "",
      "4. Страхові внески:",
      "• категорії застрахованих осіб;",
      "• ставки ЄСВ;",
      "• нарахування ЄСВ;",
      "• відображення ЄСВ у звітності.",
      "",
      "5. Виплата зарплатні:",
      "• документи на виплату в банк;",
      "• документи на виплату в касу;",
      "• особисті рахунки працівників за зарплатним проєктом;",
      "• авансові платежі;",
      "• розрахунок за місяць;",
      "• депонування зарплати;",
      "• списання депонентів у дохід підприємства/установи/організації/ФОП.",
      "",
      "6. Довідники та налаштування:",
      "• налаштування обліку зарплати;",
      "• фізичні особи;",
      "• посади;",
      "• види виплат;",
      "• параметри платіжних документів, пов'язаних із зарплатою."
    ],
    makeStyles: courseStyles
  }
},
{
  course: {
    classPrefix: "card21",
    title: "Курс (очно/онлайн)",
    name: "Податок на додану вартість (ПДВ) в програмі BAS Бухгалтерія КОРП. Підвищення кваліфікації для бухгалтера",
    start: "За запитом",
    group: "не передбачено",
    indiv: "3200 грн",
    hours: "12 ак.годин",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Лоік Інна Володимирівна",
    proviso0: "Знижка 7% — за довідкою ВПО",
    proviso1: "Знижка 10% — при оплаті повної вартості курсу одним платежем",
    proviso2: "Знижка 20% — при реєстрації від двох осіб",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "1. Налаштування розрахунків з постачальниками:",
      "- придбання товарів та запасів;",
      "- формування доручення для отримання товарів;",
      "- придбання на умовах післяплати + ПДВ;",
      "- придбання на умовах повної передоплати + ПДВ;",
      "- придбання на умовах часткової передоплати + ПДВ;",
      "- облік додаткових витрат за доставку товарів (митний брокер тощо);",
      "- повернення товарів постачальникам + ПДВ;",
      "- придбання послуг з різним призначенням витрат + ПДВ;",
      "- придбання для негосподарської діяльності + ПДВ;",
      "- витрати майбутніх періодів.",
      "",
      "2. Налаштування розрахунків з покупцями.",
      "",
      "3. Налаштування схем реалізації та договорів з покупцями:",
      "- реалізація на умовах післяплати + ПДВ;",
      "- реалізація на умовах повної передоплати + ПДВ;",
      "- реалізація на умовах часткової передоплати + ПДВ;",
      "- повернення товарів від покупців + ПДВ;",
      "- реалізація нижче собівартості + ПДВ;",
      "- реалізація в інших одиницях виміру, налаштування коефіцієнтів номенклатури.",
      "",
      "4. Роздрібна торгівля + ПДВ.",
      "",
      "5. Комісійна торгівля:",
      "- у Комітента + ПДВ;",
      "- у Комісіонера + ПДВ.",
      "",
      "6. Звірка та коригування розрахунків.",
      "",
      "7. Декларація з ПДВ."
    ],
    makeStyles: courseStyles
  }
},
{
  course: {
    classPrefix: "card22",
    title: "Курс (очно/онлайн)",
    name: "Нарахування зарплати та звітність по ній в програмі BAS Бухгалтерія КОРП. Підвищення кваліфікації для бухгалтера",
    start: "За запитом",
    group: "не передбачено",
    indiv: "4900 грн",
    hours: "12 ак.годин",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Лоік Інна Володимирівна",
    proviso0: "Знижка 7% — за довідкою ВПО",
    proviso1: "Знижка 10% — при оплаті повної вартості курсу одним платежем",
    proviso2: "Знижка 20% — при реєстрації від двох осіб",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "1. Налаштування кадрів та обліку зарплати + нормативні параметри.",
      "2. Виробничий календар та графік роботи.",
      "3. Ведення Табелю обліку робочого часу.",
      "4. Способи відображення витрат на зарплату.",
      "5. Створення посад та штатного розкладу.",
      "6. Налаштування базових місяців для розрахунку індексації.",
      "7. Налаштування параметрів виплати податків із зарплати.",
      "8. Прийом на роботу (повний день, основне місце роботи).",
      "9. Неповний робочий день (основне місце роботи та сумісництво).",
      "10. Внутрішнє сумісництво.",
      "11. Працівник з інвалідністю.",
      "12. Утримання за виконавчими листами (в т.ч. аліменти).",
      "13. Договори цивільно-правового характеру (ЦПХ).",
      "14. Відпустки: залишки, графік, розрахунок, виплата.",
      "15. Нарахування резерву відпусток.",
      "16. Лікарняні: розрахунок виплат роботодавцем та ФСС.",
      "17. Підвищення окладу та зміна інших даних.",
      "18. Розрахунок і виплата авансу за фактично відпрацьований час.",
      "19. Нарахування та виплата основної частини зарплати.",
      "20. Звільнення: нарахування та виплати при звільненні.",
      "21. Звітність по зарплаті: формування податкового розрахунку та Додатків.",
      "22. Ведення військового обліку: форми для обліку, взаємодія з військкоматами."
    ],
    makeStyles: courseStyles
  }
},
{
  course: {
    classPrefix: "card23",
    title: "Курс (очно/онлайн)",
    name: "M.E.Doc. Курси для бухгалтерів",
    start: "Щомісяця",
    group: "3410 грн",
    indiv: "5390 грн",
    hours: "10 ак.годин",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Лоік Інна Володимирівна",
    proviso0: "Знижка 7% — за довідкою ВПО",
    proviso1: "Знижка 10% — при оплаті повної вартості курсу одним платежем",
    proviso2: "Знижка 20% — при реєстрації від двох осіб",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "1. Технічні налаштування — як налаштовувати програму.",
      "2. Електронний підпис та безпечні ключі — як забезпечити безпеку даних.",
      "3. Подання звітів — як подавати декларації та звіти.",
      "4. Обмін документами — як ефективно обмінюватися електронними документами.",
      "5. Облік податків — як вести облік ПДВ та акцизного податку.",
      "6. Розрахунок зарплати — як правильно нараховувати та подавати звіти.",
      "7. Фінансова звітність — як подавати звіти для податкових органів."
    ],
    makeStyles: courseStyles
  }
},
{
  course: {
    classPrefix: "card24",
    title: "Курс (очно/онлайн)",
    name: "Резидент Дія.City. Гіг-контракт",
    start: "Щомісяця",
    group: "4700 грн",
    indiv: "8200 грн",
    hours: "24 ак.години",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Григорєва Людмила Петрівна",
    proviso0: "Знижка 7% — за довідкою ВПО",
    proviso1: "Знижка 10% — при оплаті повної вартості курсу одним платежем",
    proviso2: "Знижка 20% — при реєстрації від двох осіб",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "Модуль 1. Вступ до Дія.Сіty:",
      "• Ідея, мета та принципи роботи правового режиму Дія.Сіty.",
      "• Переваги для резидентів: податкові, юридичні, кадрові.",
      "• Вимоги до компаній-резидентів та процедура вступу.",
      "",
      "Модуль 2. Юридичні аспекти резиденства:",
      "• Реєстрація, подання заявки, підтвердження статусу резидента.",
      "• Правові наслідки втрати статусу резидента.",
      "• Зв’язок із іншими законодавчими режимами (ЗЕД, ІР).",
      "",
      "Модуль 3. Бухгалтерські аспекти діяльності резидента Дія.Сіty:",
      "• Організація бухгалтерського обліку в компанії-резиденті.",
      "• Облік виплат за гіг-контрактами: нарахування, податки, утримання.",
      "• Ведення обліку ЄСВ, ПДФО та військового збору.",
      "• Фінансова звітність резидента: особливості складання та подання.",
      "• Автоматизація обліку та використання ПЗ для обслуговування гіг-контрактів.",
      "",
      "Модуль 4. Гіг-контракт: правова природа та структура:",
      "• Що таке гіг-контракт: відмінності від трудового та цивільного договору.",
      "• Обов’язкові та рекомендовані положення гіг-контракту.",
      "• Приклади, шаблони, варіанти адаптації.",
      "",
      "Модуль 5. Податкові аспекти гіг-контракту:",
      "• Єдиний соціальний внесок та ПДФО в рамках Дія.Сіty.",
      "• Відповідальність резидента як податкового агента.",
      "• Переваги для гіг-спеціалістів та компанії.",
      "",
      "Модуль 6. Практичні кейси укладення гіг-контрактів:",
      "• Ситуації з реального бізнесу: складні та типові випадки.",
      "• Виплати, компенсації, розірвання договору.",
      "• Оформлення документації та внутрішніх положень.",
      "",
      "Модуль 7. Ризики та комплаєнс для резидентів Дія.Сіty:",
      "• Перевірки, аудити, спори з працівниками.",
      "• Мінімізація юридичних ризиків при роботі з гіг-контрактами.",
      "• Комплаєнс-програма та внутрішній контроль."
    ],
    makeStyles: courseStyles
  }
},
{
  course: {
    classPrefix: "card25",
    title: "Курс (очно/онлайн)",
    name: "Архітектура в ландшафтному дизайні. Усе про ландшафтний дизайн. Модуль 1",
    start: "Щомісяця",
    group: "8840 грн",
    indiv: "11700 грн",
    hours: "68 ак.годин",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Волкова Валерія Олександрівна",
    proviso0: "Знижка 7% — за довідкою ВПО",
    proviso1: "Знижка 10% — при оплаті повної вартості курсу одним платежем",
    proviso2: "Знижка 20% — при реєстрації від двох осіб",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "1. Мистецтво ландшафтного дизайну та професія «Ландшафтний дизайнер».",
      "• Занурення в професію та вивчення її основ.",
      "2. Історія розвитку садово-паркового мистецтва.",
      "• Від стародавніх часів до сучасних трендів.",
      "• Огляд основних типів парків та відомих садів і парків світу.",
      "3. Сучасні сади:",
      "• «Сільський» сад та стиль «кантрі».",
      "• Сад у стилі «модерн» та архітектурний сад.",
      "• Еклектика у створенні саду.",
      "4. Основи проектування:",
      "• Розробка опорного плану ділянки.",
      "• Виділення зон ділянки та створення генерального плану.",
      "• Деталізація ескізного та дендрологічного планів.",
      "5. Садовий дизайн:",
      "• Вивчення концепцій та композицій.",
      "• Майстерність перспективи та колористики.",
      "• Поєднання симетрії та асиметрії, втілення повторів та поєднань.",
      "6. Планування рельєфу та геопластика.",
      "• Техніки та методи створення ідеальних форм ландшафту.",
      "7. Елементи бруківки, сходи, доріжки, майданчики, патіо.",
      "• Проектування та реалізація функціональних зон.",
      "8. Огорожі / паркани на ділянці.",
      "• Вибір стилів та матеріалів для інтеграції в загальний дизайн.",
      "9. Основи матеріалознавства.",
      "• Натуральне та штучне каміння в дизайні ландшафту.",
      "10. Освітлення в саду.",
      "• Створення атмосфери за допомогою декоративного освітлення.",
      "11. Вертикальне планування та системи відведення води.",
      "• Техніки дренажу та створення водних об’єктів.",
      "12. Архітектурні елементи саду:",
      "• Водойми, ставки, струмки, басейни, водоспади, кам’янисті сади."
    ],
    makeStyles: courseStyles
  }
},
{
  course: {
    classPrefix: "card26",
    title: "Курс (очно/онлайн)",
    name: "Основи ґрунтознавства. Модуль 2",
    start: "Щомісяця",
    group: "1500 грн",
    indiv: "3100 грн",
    hours: "10 ак.годин",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Волкова Валерія Олександрівна",
    proviso0: "Знижка 7% — за довідкою ВПО",
    proviso1: "Знижка 10% — при оплаті повної вартості курсу одним платежем",
    proviso2: "Знижка 20% — при реєстрації від двох осіб",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "1. Ґрунти України:",
      "• Регіональні особливості та основні види ґрунтів.",
      "",
      "2. Фактори ґрунтоутворення. Типи ґрунтів:",
      "• Процеси утворення та різноманіття типів.",
      "",
      "3. Окультурювання різних типів ґрунтів:",
      "• Методи покращення для підвищення продуктивності.",
      "",
      "4. Компост:",
      "• Створення ефективного компосту для збагачення ґрунту.",
      "",
      "5. Сидерати:",
      "• Використання зелених добрив для оздоровлення та збагачення ґрунту.",
      "",
      "6. Аналіз ґрунту ділянки:",
      "• Техніки аналізу для оптимального використання."
    ],
    makeStyles: courseStyles
  }
},
{
  course: {
    classPrefix: "card27",
    title: "Курс (очно/онлайн)",
    name: "Декоративна дендрологія. Рослини у ландшафті. Модуль 3",
    start: "Щомісяця",
    group: "6240 грн",
    indiv: "8900 грн",
    hours: "48 ак.годин",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Волкова Валерія Олександрівна",
    proviso0: "Знижка 7% — за довідкою ВПО",
    proviso1: "Знижка 10% — при оплаті повної вартості курсу одним платежем",
    proviso2: "Знижка 20% — при реєстрації від двох осіб",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "1. Декоративна дендрологія:",
      "• Фундаментальні знання фізіології та екології рослин.",
      "",
      "2. Рослинні елементи саду:",
      "• Живі огорожі, поодинокі посадки, групові композиції.",
      "",
      "3. Сад безперервного цвітіння:",
      "• Створення дизайну, який забезпечує красу протягом усього року.",
      "",
      "4. Квітники:",
      "• Види та форми квітників, їх планування та дизайн.",
      "",
      "5. Альпінарії та рокарії:",
      "• Проєктування та створення природних кам'янистих садів.",
      "",
      "6. Водойми:",
      "• Інтеграція водних елементів у ландшафтний дизайн.",
      "",
      "7. Контейнерні сади:",
      "• Гнучкість та мобільність дизайну за допомогою контейнерних рослин.",
      "",
      "8. Рослини для вертикального озеленення:",
      "• Арки, перголи, навіси, декоративні ґрати.",
      "",
      "9. Декоративний город:",
      "• Рослини-компаньйони та антагоністи в органічному вирощуванні.",
      "",
      "10. Газони:",
      "• Все про види та створення ідеального газону.",
      "",
      "11. Захист дипломних проєктів:",
      "• Від генплану до деталізованого проєкту окремої зони."
    ],
    makeStyles: courseStyles
  }
},
{
  course: {
    classPrefix: "card28",
    title: "Курс (очно/онлайн)",
    name: "Догляд за садом. Вирощування рослин на ділянці. Модуль 4",
    start: "Щомісяця",
    group: "4680 грн",
    indiv: "6900 грн",
    hours: "36 ак.годин",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Волкова Валерія Олександрівна",
    proviso0: "Знижка 7% — за довідкою ВПО",
    proviso1: "Знижка 10% — при оплаті повної вартості курсу одним платежем",
    proviso2: "Знижка 20% — при реєстрації від двох осіб",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "1. Рослини для малодоглядного саду:",
      "• Техніки та вибір рослин для створення саду з мінімальним доглядом.",
      "",
      "2. Голонасінні рослини:",
      "• Вибір та агрономічні аспекти догляду за голонасінними рослинами.",
      "",
      "3. Декоративні дерева та чагарники:",
      "• Підбір та агротехнічні прийоми догляду за оздоблювальними рослинами.",
      "",
      "4. Плодово-ягідні дерева та чагарники:",
      "• Вирощування та догляд за плодовими і ягідними рослинами.",
      "",
      "5. Рослини для декоративного городу:",
      "• Створення та утримання привабливого і продуктивного декоративного городу.",
      "",
      "6. Однорічні, дворічні та багаторічні трав’янисті рослини:",
      "• Догляд за квітковими рослинами всіх типів.",
      "",
      "7. Цибулинні рослини:",
      "• Методи і стратегії догляду за цибулинними культурами.",
      "",
      "8. Ліани на ділянці:",
      "• Догляд за ліанами, створення живописних вертикальних композицій.",
      "",
      "9. Газон на ділянці та його догляд:",
      "• Підтримка ідеального стану газону.",
      "",
      "10. Сезонні роботи в саду:",
      "• Планування та виконання сезонних робіт для забезпечення здоров’я саду."
    ],
    makeStyles: courseStyles
  }
},
{
  course: {
    classPrefix: "card29",
    title: "Експрес-курс (очно/онлайн)",
    name: "Живі огорожі в ландшафтному дизайні",
    start: "Щомісяця",
    group: "3100 грн",
    indiv: "5900 грн",
    hours: "5 ак.годин",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Волкова Валерія Олександрівна",
    proviso0: "Знижка 7% — за довідкою ВПО",
    proviso1: "Знижка 10% — при оплаті повної вартості курсу одним платежем",
    proviso2: "Знижка 20% — при реєстрації від двох осіб",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "1. Різновиди живих огорож:",
      "• Листопадні та вічнозелені живі огорожі.",
      "• Стрижені та вільно зростаючі живі огорожі.",
      "• Класифікація за висотою та кількістю рядів у посадці.",
      "",
      "2. Рослини для живих огорож:",
      "• Які види рослин підходять для створення живих огорож.",
      "• Як обрати рослину саме для вашого проєкту.",
      "",
      "3. Розташування живих огорож та їх роль у ландшафтному дизайні:",
      "• Функції живих огорож.",
      "• Як гармонійно розташувати на ділянці.",
      "",
      "4. Стригти чи не стригти:",
      "• Прийоми формування та підтримання форми.",
      "",
      "5. Агротехніка:",
      "• Закладка живої огорожі.",
      "• Правильний догляд для забезпечення здоров’я та довговічності."
    ],
    makeStyles: courseStyles
  }
},
{
  course: {
    classPrefix: "card30",
    title: "Курс (змішаний формат)",
    name: "Скетчинг. Базовий курс",
    start: "Щомісяця",
    group: "до 5 осіб — 12300 грн; 5+ осіб — 9200 грн",
    indiv: "14700 грн",
    hours: "38 ак.годин",
    discount: "Знижка від 7% до 20%",
    teacher: "Викладач: Аркад'єв Дмитро Олексійович",
    proviso0: "Знижка 7% — за довідкою ВПО",
    proviso1: "Знижка 10% — при оплаті повної вартості курсу одним платежем",
    proviso2: "Знижка 20% — при реєстрації від двох осіб",
    program: "Програма курсу",
    order: "Записатись",
    courseProgram: [
      "1. Матеріали та техніки.",
      "2. Пляма, крапка, штрих. Текстури.",
      "3. Композиція і компоновка.",
      "4. Світлотінь та об'єм. Передача об'єму за допомогою світла і тіні.",
      "5. Поняття:",
      "- лінійна перспектива;",
      "- повітряна перспектива.",
      "6. Види відображень об'єктів для подання уявлення.",
      "7. Планування. Генплан.",
      "8. Об'ємно-просторовий ескіз."
    ],
    makeStyles: courseStyles
  }
},
];

const Schedule1 = () => {
  const classes = useStyles();

  return (
    <div className="schedule" id="schedule">
      <Container maxWidth="lg" className={classes.container}>
        <Grid
          container
          direction="row"
          alignItems="center"
          spacing={3}
          className={classes.grid}
        >
          <Grid item>
            <ScheduleItem courses={courses} course={courses[0].course} />
          </Grid>
          <Grid item>
            <ScheduleItem courses={courses} course={courses[1].course} />
          </Grid>
          <Grid item>
            <ScheduleItem courses={courses} course={courses[2].course} />
          </Grid>
          <Grid item>
            <ScheduleItem courses={courses} course={courses[3].course} />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

const Schedule2 = () => {
  const classes = useStyles();

  return (
    <div className="schedule">
      <Container maxWidth="lg" className={classes.container}>
        <Grid
          container
          direction="row"
          alignItems="center"
          spacing={3}
          className={classes.grid}
        >
          <Grid item>
            <ScheduleItem courses={courses} course={courses[4].course} />
          </Grid>
          <Grid item>
            <ScheduleItem courses={courses} course={courses[5].course} />
          </Grid>
          <Grid item>
            <ScheduleItem courses={courses} course={courses[6].course} />
          </Grid>
          <Grid item>
            <ScheduleItem courses={courses} course={courses[7].course} />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

const Schedule3 = () => {
  const classes = useStyles();

  return (
    <div className="schedule">
      <Container maxWidth="lg" className={classes.container}>
        <Grid
          container
          direction="row"
          alignItems="center"
          spacing={3}
          className={classes.grid}
        >
          <Grid item>
            <ScheduleItem courses={courses} course={courses[8].course} />
          </Grid>
          <Grid item>
            <ScheduleItem courses={courses} course={courses[9].course} />
          </Grid>
          <Grid item>
            <ScheduleItem courses={courses} course={courses[10].course} />
          </Grid>
          <Grid item>
            <ScheduleItem courses={courses} course={courses[11].course} />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

const Schedule4 = () => {
  const classes = useStyles();

  return (
    <div className="schedule">
      <Container maxWidth="lg" className={classes.container}>
        <Grid
          container
          direction="row"
          alignItems="center"
          spacing={3}
          className={classes.grid}
        >
          <Grid item>
            <ScheduleItem courses={courses} course={courses[12].course} />
          </Grid>
          <Grid item>
            <ScheduleItem courses={courses} course={courses[13].course} />
          </Grid>
          <Grid item>
            <ScheduleItem courses={courses} course={courses[14].course} />
          </Grid>
          <Grid item>
            <ScheduleItem courses={courses} course={courses[15].course} />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

const Schedule5 = () => {
  const classes = useStyles();

  return (
    <div className="schedule">
      <Container maxWidth="lg" className={classes.container}>
        <Grid
          container
          direction="row"
          alignItems="center"
          spacing={3}
          className={classes.grid}
        >
          <Grid item>
            <ScheduleItem courses={courses} course={courses[16].course} />
          </Grid>
          <Grid item>
            <ScheduleItem courses={courses} course={courses[17].course} />
          </Grid>
          <Grid item>
            <ScheduleItem courses={courses} course={courses[18].course} />
          </Grid>
           <Grid item>
            <ScheduleItem courses={courses} course={courses[19].course} />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

const Schedule6 = () => {
  const classes = useStyles();

  return (
    <div className="schedule">
      <Container maxWidth="lg" className={classes.container}>
        <Grid
          container
          direction="row"
          alignItems="center"
          spacing={3}
          className={classes.grid}
        >
          <Grid item>
            <ScheduleItem courses={courses} course={courses[20].course} />
          </Grid>
          <Grid item>
            <ScheduleItem courses={courses} course={courses[21].course} />
          </Grid>
          <Grid item>
            <ScheduleItem courses={courses} course={courses[22].course} />
          </Grid>
          <Grid item>
            <ScheduleItem courses={courses} course={courses[23].course} />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

const Schedule7 = () => {
  const classes = useStyles();

  return (
    <div className="schedule">
      <Container maxWidth="lg" className={classes.container}>
        <Grid
          container
          direction="row"
          alignItems="center"
          spacing={3}
          className={classes.grid}
        >
          <Grid item>
            <ScheduleItem courses={courses} course={courses[24].course} />
          </Grid>
          <Grid item>
            <ScheduleItem courses={courses} course={courses[25].course} />
          </Grid>
          <Grid item>
            <ScheduleItem courses={courses} course={courses[26].course} />
          </Grid>
          <Grid item>
            <ScheduleItem courses={courses} course={courses[27].course} />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

const Schedule8 = () => {
  const classes = useStyles();

  return (
    <div className="schedule">
      <Container maxWidth="lg" className={classes.container}>
        <Grid
          container
          direction="row"
          alignItems="center"
          spacing={3}
          className={classes.grid}
        >
          <Grid item>
            <ScheduleItem courses={courses} course={courses[28].course} />
          </Grid>
          <Grid item>
            <ScheduleItem courses={courses} course={courses[29].course} />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export { Schedule1, Schedule2, Schedule3, Schedule4, Schedule5, Schedule6, Schedule7, Schedule8 };
